import Vue from 'vue'
import Vuex from 'vuex'
import * as R from 'ramda'
import Queue from './vuex'
import configs from '../configs'
import jwt from 'jsonwebtoken'

Vue.use(Vuex)

const token = window.sessionStorage.getItem('authToken')
const tokenCompany = window.sessionStorage.getItem('authCompany')
const logoCompany = window.sessionStorage.getItem('logoCompany')

let loggedUser = (R.isNil(token) || R.isEmpty(token) || token === '') ? {} : jwt.verify(JSON.parse(token), configs.JWT_PASSWORD)
let selectedCompany = (R.isNil(tokenCompany) || R.isEmpty(tokenCompany) || tokenCompany === '') ? {} : jwt.verify(JSON.parse(tokenCompany), configs.JWT_PASSWORD)
let selectedLogo = (R.isNil(logoCompany) || R.isEmpty(logoCompany) || logoCompany === '') ? null : JSON.parse(logoCompany)

const state = {
  user: loggedUser,
  company: selectedCompany,
  logo: selectedLogo,
  ...Queue.state
}

const mutations = {
  GET_USER (state) {
    return state.user
  },

  SET_USER (state, token) {
    if (typeof token === 'string' && token !== '') {
      window.sessionStorage.setItem('authToken', JSON.stringify(token))
      loggedUser = jwt.verify(token, configs.JWT_PASSWORD)
    } else {
      window.sessionStorage.removeItem('authToken')
      loggedUser = {}
    }
    state.user = loggedUser
  },

  GET_COMPANY (state) {
    return state.company
  },

  SET_COMPANY (state, token) {
    if (typeof token === 'string' && token !== '') {
      window.sessionStorage.setItem('authCompany', JSON.stringify(token))
      selectedCompany = jwt.verify(token, configs.JWT_PASSWORD)
    } else {
      window.sessionStorage.removeItem('authCompany')
      window.sessionStorage.removeItem('logoCompany')
      selectedCompany = {}
      selectedLogo = null
    }
    state.company = selectedCompany
  },

  GET_LOGO (state) {
    return state.logo
  },

  SET_LOGO (state, logo) {
    if (typeof logo === 'string' && logo !== '') {
      window.sessionStorage.setItem('logoCompany', JSON.stringify(logo))
      selectedLogo = logo
    } else {
      window.sessionStorage.removeItem('logoCompany')
      selectedLogo = null
    }
    state.logo = selectedLogo
  },

  ...Queue.mutations
}

const actions = {
  getUser ({commit}) {
    commit('GET_USER')
  },

  setUser ({commit}, user) {
    commit('SET_USER', user)
  },

  getCompany ({commit}) {
    commit('GET_COMPANY')
  },

  setCompany ({commit}, company) {
    commit('SET_COMPANY', company)
  },

  getLogo ({commit}) {
    commit('GET_LOGO')
  },

  setLogo ({commit}, logo) {
    commit('SET_LOGO', logo)
  },

  ...Queue.actions
}

const getters = {
  getUser: state => state.user,
  getCompany: state => state.company,
  getLogo: state => state.logo,
  ...Queue.getters
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})



// WEBPACK FOOTER //
// ./src/vuex/store.js